import { Point } from '@/types';

export function isEqualPoints(d1: Point, d2: Point) {
  return (
    d1 === d2 || // either both null or same object
    (d1 &&
      d2 && // both are objects
      d1.x === d2.x &&
      d1.y === d2.y) // both objects have same values
  );
}
